var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "45px",
    viewBox: "0 0 39 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Identity-server",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login-copy-2",
    transform: "translate(-352.000000, -800.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SMG-PM/EDM-App-Hub",
    transform: "translate(352.000000, 800.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    x: 0,
    y: 0,
    width: 39,
    height: 45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 11.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88322198,6.44749607 L9.88322198,7.04469121 L7.55433973,7.04469121 L7.55433973,6.32054741 C7.55433973,4.33853898 6.79890576,3.17365085 5.03682249,3.17365085 C3.27384522,3.17365085 2.51841125,4.33853898 2.51841125,6.28925724 C2.51841125,11.2313152 9.91451215,11.7033497 9.91451215,17.9032723 C9.91451215,21.2405919 8.30977371,23.4121293 4.94205799,23.4121293 C1.57434228,23.4121293 0,21.2405919 0,17.9032723 L0,16.6445137 L2.29848609,16.6445137 L2.29848609,18.029327 C2.29848609,20.0131234 3.11650039,21.1780116 4.87858366,21.1780116 C6.64156093,21.1780116 7.45957524,20.0131234 7.45957524,18.029327 C7.45957524,13.1194532 0.0947644984,12.6483127 0.0947644984,6.44749607 C0.0947644984,3.04759619 1.66910678,0.939533104 4.97334816,0.939533104 C8.30977371,0.939533104 9.88322198,3.11107053 9.88322198,6.44749607",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "19.9625886 23.1602882 17.6024162 23.1602882 13.951301 5.62885597 13.951301 23.1915783 11.8101597 23.1915783 11.8101597 1.15972646 15.2413498 1.15972646 18.8611748 18.753739 22.3549452 1.15972646 25.7852412 1.15972646 25.7852412 23.1915783 23.456359 23.1915783 23.456359 5.47151114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3437723,8.36728177 L38.3437723,6.47914384 C38.3437723,3.14182429 36.770324,0.938996701 33.3713181,0.938996701 C30.0027084,0.938996701 28.4292601,3.14182429 28.4292601,6.47914384 L28.4292601,17.8723398 C28.4292601,21.2087653 30.0027084,23.4115929 33.3713181,23.4115929 C36.770324,23.4115929 38.3437723,21.2087653 38.3437723,17.8723398 L38.3437723,13.729522 L33.8433526,9.58491618 L32.3503648,11.2057467 L36.01489,14.5797204 L36.01489,17.9975004 C36.01489,19.9812969 35.2272719,21.1774751 33.4338985,21.1774751 C31.6709212,21.1774751 30.8529069,19.9812969 30.8529069,17.9975004 L30.8529069,6.35219517 C30.8529069,4.36929274 31.6709212,3.17311445 33.4338985,3.17311445 C35.2272719,3.17311445 36.01489,4.36929274 36.01489,6.35219517 L36.01489,8.36728177 L38.3437723,8.36728177 Z",
    id: "Fill-6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmgLogo);
export default __webpack_public_path__ + "static/media/smgLogo.bb0fa57d.svg";
export { ForwardRef as ReactComponent };